var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:'icon',attrs:{"src":("//img.drugwars.io/icons/" + _vm.name + ".png"),"width":_vm.size,"height":_vm.size}})}
var staticRenderFns = []

export { render, staticRenderFns }